"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationPlans = require("../../../../hooks/recommendation/useRecommendationPlans");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _EntelPlansTab = _interopRequireDefault(require("./EntelPlansTab"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _AdditionalPlan = _interopRequireDefault(require("../../ProductCard/AdditionalPlan"));
var _constants = require("../../../../utils/constants");
var _useCustomer = require("../../../../hooks/questionnaire/useCustomer");
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _recommendationSelectors = require("../../../../store/recommendation/recommendationSelectors");
var _DynamicRecommendationSummary = _interopRequireDefault(require("../../../DynamicRecommendationSummary/DynamicRecommendationSummary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 18px;
  ${_r10SourceLibrary.Mixins.respondTo.md(` gap: 24px;`)}
  ${_r10SourceLibrary.Mixins.respondTo.lg(` gap: 35px;`)}
`;
const EntelPlans = () => {
  const recommendationTabsCount = (0, _useConfig.default)('recommendationTabsCount', undefined);
  const displayedProductsOrder = (0, _useConfig.default)('displayedProductsOrder', _constants.DISPLAYED_PRODUCTS_ORDER);
  const hideAdditionalPlanSection = (0, _useConfig.default)('hideAdditionalPlanSection', false);
  const {
    recommendedPlan,
    premiumPlan,
    budgetPlan,
    alternativePremiumPlan,
    alternativeBudgetPlan,
    selectedPlan
  } = (0, _useRecommendationPlans.useRecommendationPlans)();
  const plans = (0, _lodash.default)([recommendedPlan, premiumPlan, alternativePremiumPlan, alternativeBudgetPlan, budgetPlan].sort((product1, product2) => {
    return displayedProductsOrder.indexOf(product1 === null || product1 === void 0 ? void 0 : product1.tier) - displayedProductsOrder.indexOf(product2 === null || product2 === void 0 ? void 0 : product2.tier);
  }).filter(plan => !!plan).slice(0, isNaN(recommendationTabsCount) ? undefined : recommendationTabsCount), p => p.productId);
  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const hideAdditionalPlan = hideAdditionalPlanSection || numberOfPlans === 1 && isCustomer;
  const planIndex = plans.findIndex(plan => plan.tier === selectedPlan.tier);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_EntelPlansTab.default, {
    plans: plans,
    selectedPlan: selectedPlan
  }), !hideAdditionalPlan && /*#__PURE__*/_react.default.createElement(_AdditionalPlan.default, {
    plan: selectedPlan,
    planIndex: planIndex
  }), /*#__PURE__*/_react.default.createElement(_DynamicRecommendationSummary.default, {
    testId: planIndex
  }));
};
var _default = EntelPlans;
exports.default = _default;